<script>
import ControlPanel from '@/components/default/views/dashboard/ControlPanel'
import EnrollmentList from '@/components/default/views/dashboard/EnrollmentList'
import gtmMixin from '@/mixins/shared/gtm-mixin'
import { mapGetters } from 'vuex'

export default {
	name: 'Dashboard',
	components: {
		ControlPanel,
		EnrollmentList
	},
	data: () => ({
		loading: true
	}),
	mixins: [gtmMixin],
	mounted () {
		this.trackGTM()
		this.$store.dispatch('loadDocumentCategories')
		this.$store.dispatch('loadEnrollmentList')
			.catch((error) => {
				console.error('Could not get enrollment list', error)
			})
			.finally((response) => {
				this.loading = false
			})
		this.$store.commit('resetSelectedDocument')
	},
	computed: {
		...mapGetters(['enrollmentList'])
	}
}
</script>

<template>
	<div class="dashboard">
		<control-panel :enrollment-list="enrollmentList" />
		<base-loading :loading="loading" modifiers="medium-spinner light-overlay" :class="{ 'dashboard__spinner' : loading }">
			<enrollment-list :enrollment-list="enrollmentList" v-show="!loading"/>
		</base-loading>
	</div>
</template>

<style lang="scss">
	.dashboard {
		display: flex;
		flex-direction: column;
		justify-content: center;
		&__spinner {
			margin-top: 2rem;
		}
	}
</style>
